import type { RegexPatterns } from '../types/RegexPatterns';

import useRegexPatternsStore from './useRegexPatternsStore';

type UseRegexPatternsReturn = {
    regexPatterns: RegexPatterns | null;
};

export default function useRegexPatterns(): UseRegexPatternsReturn {
    const regexPatternsStrings = useRegexPatternsStore((state) => state.regexPatterns);
    // Convert string patterns to RegExp objects
    const regexPatterns = regexPatternsStrings
        ? {
            common: {
                shortText: new RegExp(regexPatternsStrings.common.shortText),
                longText: new RegExp(regexPatternsStrings.common.longText),
                shortTrimmedText: new RegExp(regexPatternsStrings.common.shortTrimmedText),
                longTrimmedText: new RegExp(regexPatternsStrings.common.longTrimmedText),
                otp: new RegExp(regexPatternsStrings.common.otp),
                color: new RegExp(regexPatternsStrings.common.color),
                uuid: new RegExp(regexPatternsStrings.common.uuid),
                alphaNumeric: new RegExp(regexPatternsStrings.common.alphaNumeric),
            },
            organization: {
                name: new RegExp(regexPatternsStrings.organization.name),
            },
            users: {
                identifier: new RegExp(regexPatternsStrings.users.identifier),
                email: new RegExp(regexPatternsStrings.users.email),
                phoneWithCountryCode: new RegExp(regexPatternsStrings.users.phoneWithCountryCode),
                phoneWithoutCountryCode: new RegExp(regexPatternsStrings.users.phoneWithoutCountryCode),
                username: new RegExp(regexPatternsStrings.users.username),
                password: new RegExp(regexPatternsStrings.users.password),
                fullName: new RegExp(regexPatternsStrings.users.fullName),
            },
            vehicles: {
                vin: new RegExp(regexPatternsStrings.vehicles.vin),
                licensePlate: new RegExp(regexPatternsStrings.vehicles.licensePlate),
                name: new RegExp(regexPatternsStrings.vehicles.name),
            },
        }
        : null;

    return {
        regexPatterns,
    };
}
